// /community — real route (design doc's G1/G4, public surface). The
// original (app/community/page.tsx) is an async SERVER component doing a
// direct drizzle join at render time; there was no client sibling and no
// endpoint, so this is a small client rewrite (apps/spa/app/community/page.tsx)
// backed by a NEW `GET /api/visualizations/community` endpoint added to
// apps/server/src/routes/visualizations.ts — see that page's header comment
// for the full rationale. Public, no guard (matches core.tsx's ownership).
// Registered into the route tree from routes/core.tsx.
import { lazy } from 'react';
import { createRoute } from '@tanstack/react-router';
import { rootRoute } from './__root';

const CommunityPage = lazy(() => import('@/app/community/page'));

export const communityRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/community',
  component: CommunityPage,
});
